/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconTwitter({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" className={className} {...props} {...attrs} data-test="IconTwitter"><path fill="currentColor" d="M4.476 2A2.475 2.475 0 0 0 2 4.476v7.049A2.475 2.475 0 0 0 4.476 14h7.049A2.475 2.475 0 0 0 14 11.524V4.476A2.475 2.475 0 0 0 11.524 2H4.476zm.12 2.571h2.268l1.61 2.289 1.954-2.289h.714L8.797 7.318l2.893 4.11H9.422L7.554 8.773l-2.268 2.655h-.715l2.66-3.113-2.635-3.744zm1.094.572 4.031 5.714h.876L6.565 5.143H5.69z"/></svg>
  );
}

IconTwitter.propTypes = iconPropTypes;
IconTwitter.defaultProps = iconDefaultProps;
